import { landingPage } from "../../access/LandingPage";
import { TenantService } from "../../services/TenantService";
import type { FormEvent } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useAuth } from "../../auth/useAuth";
import { useBasePage } from "../../hooks/useBasePage";
import type { LoginState } from "./LoginState";
import { useTenant } from "../../tenant/useTenant";
import { hash } from "../../utils/Util";

interface LoginLocationState {
  from?: {
    pathname?: string;
  };
}

const initialState: LoginState = {
  email: "",
  password: "",
};

export function Login() {
  const navigate = useNavigate();
  const location = useLocation();
  const { login } = useAuth();
  const { Tenant, TenantUrl } = useTenant();
  const { state, setStateProperty, handleError } =
    useBasePage<LoginState>(initialState);
  const submit = async (event: FormEvent<HTMLFormElement>): Promise<void> => {
    event.preventDefault();

    try {
      const tenant = Tenant?.Code
        ? Tenant
        : (await TenantService().ResolveByUrl(TenantUrl)).Data[0];
      if (!tenant?.Code) {
        handleError(
          new Error("Your business could not be resolved. Please retry."),
        );
        return;
      }
      var psw = await hash(state.password);
      const session = await login({
        Email: state.email.trim(),
        Password: psw,
        Tenant: tenant.Code,
      });

      const locationState = location.state as LoginLocationState | null;
      navigate(landingPage(session,locationState?.from?.pathname), {
        replace: true,
      });
    } catch {
      // ApiInterceptor has already sent the normalized error to ErrorProvider.
    }
  };

  return {
    state,
    setStateProperty,
    submit,
  };
}
